<div class="ui-g loyality-card" *ngIf="renderTable == true">
  <div class="barcodeContainer" style="height: 0;visibility: hidden;">
    <svg id="barcode" style="height: 0;"></svg>
  </div>
  <div class="ui-g-12">
    <app-kontable #table
                  title="{{ 'customerInfoSheet.cardList' | translate }}"
                  [columns]="[
                    {field: 'card_no', title: 'card.card_no', filterType: numberFilter, bodyTemplate: cardnoTemplate},
                    {field: 'store', title: 'card.store_id'},
                    {field: 'channelDescription', title: 'card.channel_id', filterType: selectFilter, filterOptions: {values: listChannels}},
                    {field: 'cardTypeDescription', title: 'card.card_type_id', filterType: selectFilter, filterOptions: {values: listParams}},
                    {field: 'flg_blk_lst', title: flagBlackListTitle,  bodyTemplate: blacklistTemplate, filterType: customFilter, filterTemplate: customerBlacklistFilter},
                    {field: 'reasonDescription', title: 'card.reason_id', filterType: customFilter, filterTemplate: reasonCustomFilter},
                    {field: 'customerDescription', title: 'card.customerDescription', bodyTemplate: customerDescriptionTemplate, searchable: addCardPermission, sortable: addCardPermission},
                    {field: 'customerState', title: 'card.customer_state', bodyTemplate: stateTemplate, filterType: customFilter, filterTemplate: customerStateFilter},
                    {field: 'birth_date', title: 'common.birth_date',type: 'date', filterType: dateFilter},
                    {field: 'flg_dpl', title: 'Flag Deploy', filterType: customFilter, filterTemplate: flgDeployFilter},
                    {field: 'flg_state', title: 'card.status', bodyTemplate: cardStatusTemplate, filterType: customFilter, filterTemplate: flgStateFilter}
                  ]"
                  [service]="cardService"
                  [paginationType]="paginationType"
                  (onEdit)="edit($event)"
                  (onAdd)="add()"
                  (onDetails)="open($event)"
                  (onDownloadExcel)="downloadExcel($event)"
                  [additionalRowCommands]="customRowCommands"
                  [showRecoverButton]="false"
                  [showInfoButton]="false"
                  [showAddButton]="addCardPermission"
                  [showDeleteButton]="false"
                  [showDetailsButton]="cardViewPermission"
                  [showEditButton]="editCardPermission"
                  [showReport]="cardExportPermission"
                  [showDownloadExcelBtn]="cardExportExcelPermission"
                  [toolbarCustomButtons]="customButton"
                  [fireNewDataAvailable]="newDataAvailable"
                  [filterBySingleColumn]="!staticTable"
                  [showExtSearch]="true"
                  [extSearchConfigKey]="'extsearch-card'"
                  (extSearchReq)="sendExtSearchQuery($event)"
                  [extSearchResult]="extSearchResult"
                  [totalRecords]="totalRecords">

      <ng-template #customerDescriptionTemplate data-testid="customerDescriptionTemplate" let-row>
        <span *ngIf="addCardPermission">{{ row.customerDescription }}</span>
        <span *ngIf="!addCardPermission">**********</span>
      </ng-template>

      <ng-template #customButton>
        <button *ngIf="blacklistImportPermission" pButton type="button" class="k-generic-btn" icon="fa fa-upload" iconPos="left" label="{{ 'Blacklist Import' | translate }}" (click)="viewImportDialog = true;"
                style="margin-top: 7px; margin-left: 10px; height: 34px !important;"></button>
      </ng-template>

      <ng-template #reasonCustomFilter data-testid="reasonCustomFilter" let-col>
        <p-dropdown [options]="listReasons" [style]="{'width':'100%'}"  (onChange)="table.updateTableFilter('reason_id', $event.value, 'equals')" [(ngModel)]="table.filter.search[col.field]"></p-dropdown>
      </ng-template>

      <ng-template #stateTemplate data-testid="stateTemplate" let-row class="deleted-row">
        <span *ngIf="row.customerState && row.customerState == '1'" class="fa fa-trash-o" title="{{'common.deleted' | translate}}"></span>
        <span *ngIf="row.customerState && row.customerState == '2' && cardOperationsPermission" class="fa fa-ban" title="{{'common.suspended' | translate}}"></span>
      </ng-template>

      <ng-template #cardStatusTemplate data-testid="cardStatusTemplate" let-row>
        <span *ngIf="row.flg_state && row.flg_state == '0'">{{ 'card.active' | translate }}</span>
        <span *ngIf="row.flg_state && row.flg_state == '1'">{{ 'card.deleted' | translate }}</span>
      </ng-template>

      <ng-template #blacklistTemplate data-testid="blacklistTemplate" let-row class="deleted-row">
        <span *ngIf="row.flg_blk_lst != '1'">{{'card.active' | translate}}</span>
        <span *ngIf="row.flg_blk_lst && row.flg_blk_lst == '1'">{{'card.blacklist' | translate}}</span>
      </ng-template>

      <ng-template #customerStateFilter data-testid="customerStateFilter" let-col>
        <p-dropdown [options]="listStates" [style]="{'width':'100%'}" (onChange)="table.updateTableFilter(col.field, $event.value, 'equals')" [(ngModel)]="table.filter.search[col.field]"></p-dropdown>
      </ng-template>

      <!-- Filtri data prenotazione -->
    <ng-template #dateCardCustomFilter data-testid="dateCardCustomFilter" let-col>
      <p-calendar
        *ngIf="calendarTranslateService.pcalendarTranslate"
        class="calendarKontable"
        dataType="date"
        dateFormat="{{calendarTranslateService.pcalendarTranslate.dateFormat}}"
        [(ngModel)]="filterDateCard"
        [monthNavigator]="true"
        [yearNavigator]="true"
        [yearRange]="'1900:2099'"
        (ngModelChange)="onChangeDateCard('birth_date')"
        (onClearClick)="onChangeDateCard('birth_date')"
        [inputStyle]="{'width':'100%', 'height':'26px', 'border-color':'#fec55c'}"
        [readonlyInput]="true"
        showButtonBar="true">
      </p-calendar>
    </ng-template>

      <ng-template #customerBlacklistFilter data-testid="customerBlacklistFilter" let-col>
        <p-dropdown [options]="listBlacklist" [style]="{'width':'100%'}" (onChange)="table.updateTableFilter(col.field, $event.value, 'equals')" [(ngModel)]="table.filter.search[col.field]"></p-dropdown>
      </ng-template>

      <ng-template #flgDeployFilter data-testid="flgDeployFilter" let-col>
        <p-dropdown [options]="flgDplStates" [style]="{'width':'100%'}" (onChange)="table.updateTableFilter(col.field, $event.value, 'equals')" [(ngModel)]="table.filter.search[col.field]"></p-dropdown>
      </ng-template>

      <ng-template #flgStateFilter data-testid="flgStateFilter" let-col>
        <p-dropdown [options]="flgStates" [style]="{'width':'100%'}" (onChange)="table.updateTableFilter(col.field, $event.value, 'equals')" [(ngModel)]="table.filter.search[col.field]"></p-dropdown>
      </ng-template>

      <ng-template #cardnoTemplate data-testid="cardnoTemplate" let-row>
        <span style="margin-right:5px;" [textContent]="row.card_no"></span>
        <i style="cursor:pointer;" *ngIf="mgPermission" class="fa fa-barcode" (click)="onClickVisualizzaBarcode(row.card_no)"></i>
      </ng-template>

      <ng-template #customRowCommands data-testid="customRowCommands" let-row>
        <p-button pTooltip="{{ 'card.blacklist' | translate }}" label="" icon="fa fas fa-ban" styleClass="ui-button-blacklist" *ngIf="(!row.flg_state || row.flg_state === '0') && !isBlacklistedCard(row) && cardOperationsPermission" (onClick)="showBlackListCardModal(row)"></p-button>
        <p-button pTooltip="{{ 'card.replace' | translate }}" label="" icon="fa fas fa-retweet" styleClass="ui-button-warning" *ngIf="(!row.flg_state || row.flg_state === '0') && !isBlacklistedCard(row) && isReplaceable(row) && cardOperationsPermission && !cardHideSubtituteOperationsPermission" (onClick)="showReplaceCardModal(row)"></p-button>
        <p-button pTooltip="{{ 'common.customer' | translate }}" label="" icon="fa fas fa-user" styleClass="ui-button-info" *ngIf="row.customerState == '0' && cardCustomerPermission" (onClick)="goToCustomer(row)"></p-button>
        <p-button pTooltip="{{ 'movement.add_title' | translate }}" label="" *ngIf="row.customerState == '0' && cardMovementPermission && !isBlacklistedCard(row)" icon="fa fas fa-arrows" styleClass="ui-button-info" (onClick)="onClickAddMovement(row)"></p-button>
        <p-button pTooltip="{{ 'card.downloadPdf' | translate }}" *ngIf="row.pdf_link" icon="fa fa-file-pdf-o" styleClass="ui-button-info" (onClick)="downloadPdf(row.pdfUrl)"></p-button>

        <!-- Button balances -->
        <svg
          version="1.0"
          xmlns="http://www.w3.org/2000/svg"
          width="565.000000pt"
          height="557.000000pt"
          viewBox="0 0 565.000000 557.000000"
          preserveAspectRatio="xMidYMid meet"
          pTooltip="{{ 'loyalty.balance' | translate }}"
          *ngIf="row.flg_blk_lst !== '1' && row.customerHostId && reservationPermission"
          (click)="goToCustomerBalance(row)"
          class="button-saldi">
          <g transform="translate(0.000000,557.000000) scale(0.100000,-0.100000)"
          fill="#2b4579" stroke="none">
          <path d="M1692 5493 c-68 -33 -103 -115 -82 -188 7 -22 128 -214 269 -427
          l256 -388 685 0 685 0 256 388 c141 213 262 404 268 425 23 69 -13 153 -80
          187 -37 20 -63 20 -1131 20 -988 0 -1096 -2 -1126 -17z"/>
          <path d="M2025 4081 c-694 -421 -1174 -880 -1519 -1450 -158 -261 -292 -595
          -357 -893 -43 -196 -53 -305 -54 -563 0 -230 2 -257 23 -333 61 -224 201 -420
          399 -562 136 -96 259 -152 448 -203 l80 -22 1720 -3 c1190 -2 1745 0 1803 8
          478 63 880 409 968 836 23 112 15 497 -15 669 -101 585 -341 1085 -757 1575
          -91 107 -341 353 -459 451 -224 187 -440 341 -678 483 l-128 76 -682 -1 -682
          -1 -110 -67z m920 -803 c43 -19 55 -56 55 -166 l0 -99 72 -12 c84 -14 183 -51
          253 -97 49 -31 75 -66 75 -102 0 -19 -161 -183 -198 -201 -19 -10 -32 -8 -80
          16 -57 28 -58 28 -287 31 -217 3 -232 2 -263 -18 -83 -51 -83 -211 0 -264 13
          -8 147 -51 298 -96 151 -45 304 -96 339 -113 82 -40 186 -142 229 -223 136
          -261 27 -577 -243 -705 -33 -16 -75 -31 -92 -34 -18 -3 -49 -7 -68 -10 l-35
          -6 0 -104 c0 -102 -1 -106 -29 -137 l-29 -33 -121 0 c-118 0 -121 1 -148 28
          -27 26 -28 33 -33 140 l-5 112 -50 6 c-111 14 -233 65 -305 126 -65 56 -59 78
          53 184 50 49 100 92 110 95 11 3 45 -6 80 -23 61 -28 64 -28 282 -31 195 -2
          224 -1 254 15 98 51 94 232 -6 276 -21 10 -155 51 -298 93 -301 88 -371 120
          -462 212 -155 157 -194 378 -101 574 77 161 226 271 399 294 l49 7 0 109 c0
          108 0 110 29 139 29 29 31 29 140 29 64 0 121 -5 136 -12z"/>
          </g>
        </svg>
        <!-- Fine Button Balances -->

        <!-- Customer Oblivion Button-->
        <p-button *ngIf="customerOblivionPermission && row.flg_oblivion != '1'" pTooltip="{{ 'customerOblivion.oblivionCustomer' | translate }}" icon="fa fa-remove" styleClass="ui-button-info" (click)="oblivionCustomer(row.vCustomerId)">
        </p-button>

        <!-- decommentare per attivare la domiciliazione -->
        <!--<p-button label="" icon="fa fas fa-credit-card" styleClass="ui-button-info" *ngIf="(!row.flg_state || row.flg_state === '0') && !isBlacklistedCard(row) && cardOperationsPermission" (onClick)="showDomiciliationCardModal(row)"></p-button>-->
      </ng-template>
    </app-kontable>
  </div>


  <p-dialog [(visible)]="viewImportDialog" header="Blacklist import" (onHide)="closeDialog()" [modal]="true" [draggable]="false" [resizable]="false" [width]="500">
    <div class="ui-dialog-content">
      <div class="ui-g-12 ui-md-12">
        <p-fileUpload #form data-testid="form" name="blacklistimport[]" customUpload="true" multiple="false" auto="true" (uploadHandler)="onBlacklistFileUpload($event, form)"></p-fileUpload>
      </div>
    </div>

    <div *ngIf="this.blacklistFile!=null" class="ui-g-12 ui-md-12" style="display: flex; justify-content: center;">
      <button pButton class="k-generic-btn" type="button" icon="fa fa-play" iconPos="left" label="{{ 'Run Import' | translate }}" (click)="runImportBlacklist(form)"></button>
    </div>

    <div class="ui-g-12 ui-md-12">
      <span class="label" style="margin-left: 20px"> {{ 'Esito operazione: ' | translate }} </span>
    </div>

    <div class="ui-g-12 ui-md-12" >
      <textarea id="textarea" pInputTextarea rows="10" class="notes-input" cols="50" [(ngModel)]="stringaEsito"
                  style="resize: none; display: block; margin-left: auto; margin-right: auto;" readonly></textarea>
    </div>

    <div class="ui-dialog-footer">
      <div class="ui-g-6 ui-md-6" style="display: flex; justify-content: center; margin-top: 5px; margin-bottom: 10px;">
        <button pButton class="k-generic-btn" type="button" label="{{ 'Copy to clipboard' | translate }}" (click)="copyToClipboard()"></button>
      </div>
    </div>

    <div class="ui-dialog-footer">
      <div class="ui-g-6 ui-md-6" style="display: flex; justify-content: center; margin-top: 5px; margin-bottom: 10px;">
        <button pButton class="k-generic-btn" type="button" label="{{ 'Fine' | translate }}" (click)="closeDialog()"></button>
      </div>
    </div>

  </p-dialog>



  <p-dialog
  header="{{ ('card.blacklistCardCustomer' | translate).replace('{cartno}', cardToBlacklistNo) }}"
  [minWidth]="600"
  [width]="600"
  [(visible)]="showBlackListModal"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  (onHide)="closeBlacklistModal()">

    <div class="ui-dialog-content">
      <div class="ui-g-12 ui-md-12 user-data-container" *ngIf="!addCardPermission">
        <h4>Dati Utente</h4>
        <div class="ui-g-12 ui-lg-4">
          <span class="label">{{ 'common.surname' | translate }} *</span>
          <p>
            <input type="text" pInputText [(ngModel)]="userWithoutPermissions.surname">
          </p>
        </div>
        <div class="ui-g-12 ui-lg-4">
          <span class="label">{{ 'common.name' | translate }} *</span>
          <p>
            <input type="text" pInputText [(ngModel)]="userWithoutPermissions.name">
          </p>
        </div>
        <div class="ui-g-12 ui-lg-4">
          <span class="label">{{ 'common.birth_date' | translate }} *</span>
          <p>
            <p-calendar
            dateFormat="dd/mm/yy"
            dataType="string"
            [(ngModel)]="userWithoutPermissions.birthDate"
            [monthNavigator]="true"
            [yearNavigator]="true"
            [yearRange]="'1900:2099'"
            [placeholder]="'dd/mm/yy'">
            </p-calendar>
          </p>
        </div>
      </div>
      <div class="ui-g-12 ui-md-12">
        <div class="ui-g-12 ui-md-6">
          <span class="label">{{ 'card.selectBlacklistReason' | translate }}</span>
          <p-dropdown [options]="blacklistReasons" #blacklistReason data-testid="blacklistReason" [ngModel]="selectedBlackListReason" [style]="{'width':'100%'}"></p-dropdown>
        </div>
      </div>
    </div>

    <div class="ui-dialog-footer" *ngIf="showBlackListModal">
      <button
      *ngIf="cardOperationsPermission"
      type="button"
      pButton
      [ngClass]="{'substitutionBtnDisabled' : !addCardPermission && (!userWithoutPermissions.surname || !userWithoutPermissions.name || !userWithoutPermissions.birthDate)}"
      class="ui-button-success btnDelete"
      icon="fa fa-ban"
      (click)="blacklistCard(blacklistReason, table)"
      label="Blacklist"
      [disabled]="!addCardPermission && (!userWithoutPermissions.surname || !userWithoutPermissions.name || !userWithoutPermissions.birthDate)"
      ></button>
      <button type="button" pButton class="ui-button-danger btnDelete" icon="fa fa-close" (click)="closeBlacklistModal()" label="{{ 'common.cancel' | translate }}"></button>
    </div>
  </p-dialog>

  <p-dialog
  header="{{ ('card.replaceCardCustomer' | translate).replace('{cartno}', cardToReplace == null ? '': cardToReplace.card_no) }}"
  [(visible)]="showReplaceModal"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  (onHide)="closeReplaceModal(replaceReason)"
  class="replace-card-dialog">
    <div class="ui-dialog-content">

      <div class="ui-g-12 ui-md-12">
        <div class="ui-g-12 ui-md-6">
          <span class="label">{{ 'card.selectCardCustomer' | translate }} *</span>
          <p>
            <p-autoComplete
            [(ngModel)] = "newCardReplace"
            [suggestions]="cardsModal"
            (completeMethod)="filterCardSingle($event)"
            (onClear)="cardNotAvailable = false"
            placeholder="Select..."
            [minLength]="2"
            field="cardNo"
            [style]="{'width': '100%'}">
            <ng-template let-card pTemplate="item">
              <div class="ui-helper-clearfix" style="border-bottom:1px solid #D5D5D5">
                <div>{{ card.cardNo }}</div>
              </div>
            </ng-template>
            </p-autoComplete>
          </p>
          <span *ngIf="cardNotAvailable" class="input-error-notification">{{ 'card.notAvailable' | translate }}</span>
        </div>
      </div>

      <div class="ui-g-12 ui-md-12 user-data-container" *ngIf="!addCardPermission">
        <h4>Dati Utente</h4>
        <div class="ui-g-12 ui-lg-4">
          <span class="label">{{ 'common.surname' | translate }} *</span>
          <p>
            <input type="text" pInputText [(ngModel)]="userWithoutPermissions.surname">
          </p>
        </div>
        <div class="ui-g-12 ui-lg-4">
          <span class="label">{{ 'common.name' | translate }} *</span>
          <p>
            <input type="text" pInputText [(ngModel)]="userWithoutPermissions.name">
          </p>
        </div>
        <div class="ui-g-12 ui-lg-4">
          <span class="label">{{ 'common.birth_date' | translate }} *</span>
          <p>
            <p-calendar
            dateFormat="dd/mm/yy"
            dataType="string"
            [(ngModel)]="userWithoutPermissions.birthDate"
            [monthNavigator]="true"
            [yearNavigator]="true"
            [yearRange]="'1900:2099'"
            [placeholder]="'dd/mm/yy'">
            </p-calendar>
          </p>
        </div>
      </div>

      <div class="ui-g-12 ui-md-12">
        <div class="ui-g-12 ui-md-6">
          <span class="label">{{ 'card.reason_id' | translate }} *</span>
          <p>
            <p-dropdown
            placeholder="Select..."
            [options]="blacklistReasons"
            (onChange)="reasonSelectedHandler()"
            #replaceReason></p-dropdown>
          </p>
        </div>
      </div>

      <div class="ui-g-12" *ngIf="show.substitutionOk">
        <span class="label" style="color:green">{{'card.substitution_ok' | translate}}</span>
      </div>

    </div>
    <div class="ui-dialog-footer">
      <button
      *ngIf="mgPermission"
      [disabled]="!show.downloadSubstituteModule"
      type="button"
      pButton
      pTooltip="{{'upload.download_file' | translate}}"
      class="ui-button-warning btnDelete"
      icon="fa fas fa-file"
      iconPos="left"
      [ngClass]="{'substitutionBtnDisabled' : !show.downloadSubstituteModule}"
      (click)="onClickScaricaModuloVuoto()"
      label="Download"></button>

      <button
      *ngIf="cardOperationsPermission && !cardHideSubtituteOperationsPermission"
      [disabled]="show.downloadSubstituteModule || !substitutionDisabled.cardSelected || !substitutionDisabled.reasonSelected || (!addCardPermission && (!userWithoutPermissions.surname || !userWithoutPermissions.name || !userWithoutPermissions.birthDate))"
      type="button"
      pButton
      [ngClass]="{'substitutionBtnDisabled' : !substitutionDisabled.cardSelected || show.downloadSubstituteModule || !substitutionDisabled.reasonSelected || (!addCardPermission && (!userWithoutPermissions.surname || !userWithoutPermissions.name || !userWithoutPermissions.birthDate))}"
      class="ui-button-success btnDelete"
      icon="fa fa-retweet"
      iconPos="left"
      (click)="confirm(replaceReason)"
      label="{{ 'card.replace' | translate }}"></button>
      <button
      type="button"
      pButton
      class="ui-button-danger btnDelete"
      icon="fa fa-close"
      iconPos="left"
      (click)="closeReplaceModal(replaceReason)"
      label="{{ 'common.cancel' | translate }}"></button>
    </div>
  </p-dialog>

  <p-confirmDialog key="conferma"></p-confirmDialog>

  <p-dialog *ngIf="selectedCard && filteredStoresByChannel && currentStore"
            header="{{ 'card.domiciliation' | translate }}"
            (onHide)="undoDomiciliation()"
            [(visible)]="showDomiciliationModal"
            [modal]="true"
            [draggable]="false"
            [resizable]="false">
    <kv-card-domiciliation
      [card]="selectedCard"
      [filteredStores]="filteredStoresByChannel"
      [currentStore]="currentStore"
      (onCancel)="undoDomiciliation()"
      (onSave)="performDomiciliation($event)"
    ></kv-card-domiciliation>
  </p-dialog>

  <!-- modal per inserimento di un movimento -->
  <p-dialog *ngIf="showMovementForm"
            header="{{ 'movement.add_title' | translate }}"
            [(visible)]="showMovementForm"
            [modal]="true"
            [draggable]="true"
            [positionLeft]="0"
            [positionTop]="0"
            [width]="'100%'">

    <app-form-movement-loyalty
      [card_id]="movementCardId"
      (onSaved)="movementSaved($event)"

    ></app-form-movement-loyalty>

  </p-dialog>

  <p-dialog *ngIf="showBarcodeModal" header="Show Barcode" [(visible)]="showBarcodeModal" [modal]="true" [draggable]="true" position="top" [closable]="true">
    <img [src]="srcBarcode" alt="source Barcode" />
  </p-dialog>


</div>



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-card/loyalty-card.component.html